import { oc } from '@orpc/contract'
import { z } from 'zod'

export const healthContract = oc.input(z.object({}).optional()).output(
  z.object({
    status: z.literal('ok'),
    timestamp: z.string(),
  })
)
